(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["accordion"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('accordion-content')) {
    customElements.define(
      'accordion-content',
      class AccordionContent extends HTMLElement {
        connectedCallback() {
          if (this.dataset.initialized) return;
          this.dataset.initialized = 'true';

          this.details = this.closest('details');
          this.summary = this.details.querySelector('.accordion__summary');

          this.summary.addEventListener('click', this.onSummaryClick.bind(this));
        }

        onSummaryClick(event) {
          event.preventDefault();

          if (this.dataset.animating === 'true') return;

          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            if (this.details.open) {
              this.details.removeAttribute('open');
            } else {
              this.closeSiblings();
              this.details.setAttribute('open', '');
            }
            return;
          }

          if (this.details.open) {
            this.close();
          } else {
            this.openAccordion();
          }
        }

        getSiblings() {
          const parent = this.details.parentElement;
          if (!parent) return [];

          return Array.from(parent.querySelectorAll('details.accordion')).filter(
            (accordion) => accordion !== this.details
          );
        }

        closeSiblings() {
          for (const sibling of this.getSiblings()) {
            if (sibling.open) {
              sibling.querySelector('accordion-content')?.close();
            }
          }
        }

        openAccordion() {
          this.closeSiblings();
          this.dataset.animating = 'true';
          this.details.setAttribute('open', '');

          this.style.gridTemplateRows = '0fr';
          requestAnimationFrame(() => {
            this.style.gridTemplateRows = '1fr';
          });

          this.addEventListener(
            'transitionend',
            () => {
              this.style.gridTemplateRows = '';
              delete this.dataset.animating;
            },
            { once: true }
          );
        }

        close() {
          this.dataset.animating = 'true';
          this.style.gridTemplateRows = '0fr';

          this.addEventListener(
            'transitionend',
            () => {
              this.details.removeAttribute('open');
              this.style.gridTemplateRows = '';
              delete this.dataset.animating;
            },
            { once: true }
          );
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["announcement-bar"] && !Shopify.designMode) return;
  try {
    const STORAGE_KEY = 'announcement-bar-dismissed';

  const dismissBar = (bar) => {
    sessionStorage.setItem(STORAGE_KEY, 'true');
    document.documentElement.classList.add('announcement-bar-dismissed');
    bar.classList.add('announcement-bar--dismissed');
  };

  document.addEventListener('click', (event) => {
    const closeButton = event.target.closest('[data-announcement-bar-close]');

    if (!closeButton) return;

    const bar = closeButton.closest('[data-announcement-bar]');

    if (bar) dismissBar(bar);
  });

  if (sessionStorage.getItem(STORAGE_KEY) === 'true') {
    document.querySelectorAll('[data-announcement-bar]').forEach((bar) => {
      bar.classList.add('announcement-bar--dismissed');
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["article-share"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('share-links')) {
    customElements.define('share-links', class ShareLinks extends HTMLElement {
      connectedCallback() {
        this.url = this.dataset.url;
        this.copiedLabel = this.dataset.copiedLabel || 'Copied';
        this.buttons = Array.from(this.querySelectorAll('[data-copy-link]'));
        this.onClick = this.onClick.bind(this);

        this.buttons.forEach((button) => {
          button.addEventListener('click', this.onClick);
        });
      }

      disconnectedCallback() {
        this.buttons.forEach((button) => {
          button.removeEventListener('click', this.onClick);
        });

        if (this.resetTimeout) {
          clearTimeout(this.resetTimeout);
        }
      }

      onClick(event) {
        const button = event.currentTarget;
        const label = button.querySelector('[data-copy-label]');

        navigator.clipboard.writeText(this.url).then(() => {
          if (!label) return;

          if (!button.dataset.originalLabel) {
            button.dataset.originalLabel = label.textContent;
          }

          label.textContent = this.copiedLabel;

          if (this.resetTimeout) {
            clearTimeout(this.resetTimeout);
          }

          this.resetTimeout = setTimeout(() => {
            label.textContent = button.dataset.originalLabel;
          }, 2000);
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["country-selector"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('currency-selector')) {
    customElements.define('currency-selector', class CurrencySelector extends HTMLElement {
      constructor() {
        super();

        this.onChange = this.onChange.bind(this);
      }

      connectedCallback() {
        this.select = this.querySelector('select');
        this.selectedValue = this.select.value;

        this.select.addEventListener('change', this.onChange);
      }

      disconnectedCallback() {
        this.select.removeEventListener('change', this.onChange);
      }

      onChange() {
        const countryCode = this.select.value;

        if (countryCode === this.selectedValue) {
          return;
        }

        const root = window.Shopify?.routes?.root || '/';
        const formId = `localization-${Date.now()}`;
        const form = document.createElement('form');

        form.id = formId;
        form.method = 'POST';
        form.action = `${root}localization`;
        form.hidden = true;

        const fields = {
          form_type: 'localization',
          utf8: '✓',
          _method: 'PUT',
          country_code: countryCode,
          language_code: this.dataset.languageCode,
          return_to: `${window.location.pathname}${window.location.search}`,
        };

        Object.entries(fields).forEach(([name, value]) => {
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = name;
          input.value = value;
          form.appendChild(input);
        });

        document.body.appendChild(form);
        form.submit();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
